import React, { useContext } from 'react';
import { useTheme } from 'ThemeContext';

import { Wrapper, Title, Box, Image } from './WidgetList.style';
import { AppSettingsContext } from 'AppSettingsContext';

import WidgetItem from '../WidgetItem';
import Snail from '../../../assets/Images/snail.svg';

function WidgetList({
  title = '',
  titleColor = undefined,
  titleBackground = undefined,
  data = []
}) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);
  return (
    <Wrapper>
      {title && (
        <Title
          theme={theme.widgetList.title}
          titleColor={titleColor}
          titleBackground={titleBackground}
        >
          {appSettings.theme === 4 ? <Image src={Snail} alt=''></Image> : ' '}
          {title}
        </Title>
      )}
      <Box theme={theme.widgetList.box}>
        {data &&
          data.map((item, key, data) => (
            <WidgetItem
              key={key}
              isCollection={true}
              isFirstCollection={key === 0 ? true : undefined}
              isLastCollection={key === data.length - 1 ? true : undefined}
              data={item}
            />
          ))}
      </Box>
    </Wrapper>
  );
}

export default WidgetList;
